import {
  FileText,
  Mail,
  Bell,
  AlertTriangle,
  Scale,
  Briefcase,
  Gavel,
  Zap,
  CheckCircle2,
  type LucideIcon,
} from 'lucide-react';
import { useApp } from '@/contexts/AppContext';

type StageConfig = {
  label: string;
  icon: LucideIcon;
  classes: string;
};

const STAGE_CONFIG: Record<number, StageConfig> = {
  0: { label: 'Forderung offen',  icon: FileText,      classes: 'bg-gray-100 text-gray-600 hover:bg-gray-200' },
  1: { label: 'Anschreiben',      icon: Mail,           classes: 'bg-blue-100 text-blue-700 hover:bg-blue-200' },
  2: { label: 'Erinnerung',       icon: Bell,           classes: 'bg-blue-100 text-blue-700 hover:bg-blue-200' },
  3: { label: '1. Mahnung',       icon: AlertTriangle,  classes: 'bg-yellow-100 text-yellow-700 hover:bg-yellow-200' },
  4: { label: '2. Mahnung',       icon: AlertTriangle,  classes: 'bg-orange-100 text-orange-700 hover:bg-orange-200' },
  5: { label: 'Inkasso',          icon: Scale,          classes: 'bg-red-100 text-red-700 hover:bg-red-200' },
  6: { label: 'Anwalt',           icon: Briefcase,      classes: 'bg-red-100 text-red-700 hover:bg-red-200' },
  7: { label: 'Klage',            icon: Gavel,          classes: 'bg-red-100 text-red-800 hover:bg-red-200' },
  8: { label: 'Vollstreckung',    icon: Zap,            classes: 'bg-red-200 text-red-900 hover:bg-red-300' },
  9: { label: 'Bezahlt',          icon: CheckCircle2,   classes: 'bg-green-50 text-zinc-500' },
};

export function ForderungStagePill({
  stage,
  forderungsAkteId,
}: {
  stage: number;
  forderungsAkteId?: string | null;
}) {
  const { openForderungsmanager } = useApp();
  const config = STAGE_CONFIG[stage] ?? STAGE_CONFIG[0];
  const Icon = config.icon;
  const isTerminal = stage === 9;

  if (isTerminal) {
    return (
      <span
        data-testid="forderung-stage-pill"
        data-stage={stage}
        className={`inline-flex items-center gap-1 text-[10px] font-semibold px-2 py-0.5 rounded-full flex-shrink-0 ${config.classes}`}
        title={config.label}
      >
        <Icon className="w-3 h-3" />
        <span>{config.label}</span>
      </span>
    );
  }

  return (
    <button
      type="button"
      data-testid="forderung-stage-pill"
      data-stage={stage}
      onClick={() => openForderungsmanager(forderungsAkteId ?? undefined)}
      className={`inline-flex items-center gap-1 text-[10px] font-semibold px-2 py-0.5 rounded-full flex-shrink-0 transition-colors cursor-pointer ${config.classes}`}
      title={`Forderung: ${config.label} — Forderungsmanager öffnen`}
    >
      <Icon className="w-3 h-3" />
      <span>{config.label}</span>
    </button>
  );
}
